<div class="main-div">
  <div class="selectGroup-section">
    <h2 class="selectGroup-heading">Select a group</h2>
    <br>

    <div class="selectGroup-info">
      <p class="selectGroup-sub-heading">Select the group you want to move your device(s) into:</p>

      <!-- <div class="error-container" aria-live="assertive">
        <div class="alert valign-children-middle" *ngIf="existingFlag">
          <div class="alert-error" aria-label="Alert.">
            <i class="icon-badgealert" aria-hidden="true"></i>
          </div>
          <div>
            <p>This group name already exists. Please select this group from the list below.</p>
          </div>
        </div>
      </div> -->

      <!-- <p *ngIf="existingFlag" class="existingAlert">*This group name already exists. Please select this group from the list below.</p> -->
      <div class="selectGroup-value">
        <label class="radio list-buttons">
          <input type="radio" class="group-options" aria-labelledby="select" name="groupSelection" value="Default Group"
            (click)="groupSelected($event)" [checked]="!createGroupFlag && ('Default Group' === groupSelection)">
          <i class="skin"></i>
          <span class="subLabel">Default Group</span>
        </label>
      </div>


      <div class="selectGroup-value" *ngFor="let group of existingGroupArray">

        <label class="radio list-buttons">
          <input type="radio" class="group-options" aria-labelledby="select" name="groupSelection" value="{{group}}"
            (click)="groupSelected($event)" [checked]="!createGroupFlag && (group === groupSelection)">
          <i class="skin"></i>
          <span class="subLabel">{{group}}</span>
        </label>
      </div>

      <div class="selectGroup-value">
        <label class="radio list-buttons">
          <input type="radio" class="group-options" aria-labelledby="select" name="groupSelection" value="Create a new group"
            (click)="groupSelected($event)" [checked]="createGroupFlag">
          <i class="skin"></i>
          <span class="subLabel">Create a new group</span>
        </label>
        <div>
          <input type="text" *ngIf="createGroupFlag" class="form-control newGroupName" [formControl]="createGroup"
            [(ngModel)]="groupSelection" (ngModelChange)="newGroupCreation($event)" autofocus="autofocus"
            placeholder="Enter a group name" />

          <div class="group-error-field errorDisplay" *ngIf="createGroupFlag && (isGroupInvalid)">
            <!-- <div class="text-danger">
                {{this.isGroupEmpty && this.createGroupFlag? 'Enter name plz' :( this.isGroupInvalid && this.createGroupFlag? 'Invalid name':'')}}
            </div> -->
            <div class="text-danger">
              {{'Please input a valid group name'}}
            </div>
          </div>

          <div class="group-error-field errorDisplay" *ngIf="existingFlag">
            <div class="text-danger">
              {{'This group name already exists. Please select this group from the list above.'}}
            </div>
          </div>

        </div>
        <p class="notification" *ngIf="createGroupFlag">*Group names can only include letters a-z, numbers 0-9 and
          space. The maximum character length is 30 characters.</p>
      </div>
      <hr id="lineStyle">

      <div id="button-section" class="row live">
        <div class="col-sm-12 col-md-12 text-right">
          <button class="btn btn-secondary pull-right continue-btn btn-width"
            [disabled]="!groupSelection || existingFlag || (createGroupFlag && (isGroupInvalid) ) " (click)="continue()">Continue</button>
          <a href="javascript:void(0)" class="btn btn-link btn-block btn-cancel btn-width" (click)="clickBack()">Back</a>
          <a href="javascript:void(0)" class="btn btn-link btn-block btn-cancel btn-width"
            (click)="clickCancel()" >Cancel</a>
        </div>
      </div>

    </div>

  </div>
</div>